import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

export const AdminView = () => {
  return (
    <div>
      <h2>Admin List</h2>
      <div>Admin list are here</div>
    </div>
  );
}
